import React from 'react';
import { timeout_finalLimit } from '../../../config/auth.config';

import Modal from '../modal';
import { useIdleTimer } from 'react-idle-timer';

import './inactivity-modal.scss';

const InactivityModal = ({ handleLogout, handleResume }: {handleLogout: Function, handleResume: Function}) => {

  const handleOnIdle = (e: Event) => {
    handleLogout();
  };

  useIdleTimer({
    timeout: timeout_finalLimit,
    onIdle: handleOnIdle,
    debounce: 500
  });

  return (
    <Modal>
      <div className='logoutwarning'>
        <div className='warning-content'>
          <p className='warning-title'>TIMEOUT WARNING</p>
          <p className='warning-text'>
            You will be logged out in <br />
            <b>5 minutes</b> due to inactivity.
          </p>
        </div>
        <div className='warning-footer'>
          <button onClick={() => handleLogout()} className='warning-close'>
            Logout
          </button>
          <button onClick={() => handleResume()} className='warning-resume'>
            Resume Session
          </button>
        </div>
      </div>
    </Modal>

  );
};

export default InactivityModal;